// extracted by mini-css-extract-plugin
export default {"accordion":"styles_accordion__YqOjY","summary":"styles_summary__8fwTJ"};